/**
 * @module dom
 */

/**
 * interface of options of insertScript.
 */
export interface InsertScriptOptions {
	async?: boolean;
	defer?: boolean;
}

export function insertScript(
	id: string,
	src: string,
	options: InsertScriptOptions = { async: true, defer: true }
): boolean {
	if (document.getElementById(id)) {
		return false;
	}

	const jss = document.getElementsByTagName('script')[0];
	const js = document.createElement('script');

	js.id = id;
	js.src = src;

	if (options.async) {
		js.async = true;
	}

	if (options.defer) {
		js.defer = true;
	}

	if (jss && jss.parentNode) {
		jss.parentNode.insertBefore(js, jss);
	}

	return true;
}
